import { useMemo } from "react";

const MOBILE_REGEX =
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;

/**
 * SEO / social crawlers — always treated as desktop so they mount the
 * desktop React tree (Helmet meta, HeaderPage SEO nav, detail *Seo).
 * Must run before MOBILE_REGEX: smartphone Googlebot contains "Mobile".
 */
const BOT_REGEX =
  /googlebot|google-inspectiontool|googleother|bingbot|bingpreview|slurp|duckduckbot|baiduspider|yandexbot|applebot|facebookexternalhit|twitterbot|linkedinbot|semrushbot|ahrefsbot|dotbot|bytespider|petalbot|\bbot\b|crawler|spider/i;

function isSeoBot(userAgent: string): boolean {
  return BOT_REGEX.test(userAgent);
}

function detectMobile(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  // Crawlers always get desktop UI for consistent SEO indexing
  if (isSeoBot(ua)) return false;
  return MOBILE_REGEX.test(ua);
}

export function useIsMobile(): boolean {
  return useMemo(() => detectMobile(), []);
}
